import {
  SettingsSlotsContainerState,
  SlotsContainerState,
} from './multi-state-box';

enum SlotId {
  S1 = 'cf2520ff-b41b-408f-bf55-192e0e307560',
  S2 = '81752652-1667-47b2-94e3-49aabab38602',
  S3 = 'e06c5470-7c45-4ba0-a9b5-384c19502287',
  S4 = 'a6db7497-d3fe-455f-9c9b-0a07fe506d87',
  S5 = '3842f82f-412a-4624-8224-a9653fa6a5f5',
  S6 = '69c9a0ce-43a2-483c-afd9-bf60ae469aa2',
  S7 = '8dff8fd3-ef25-46ea-9613-9331d8e7f73f',
  S8 = 'dfee5370-1808-46e7-9c24-462ea57da7c1',
  S9 = 'eb34cb9f-bf3b-4928-a3a3-d6d0107b3028',
  S10 = '0391683a-ba6b-4310-8f08-169f64f7b5cc',
  S11 = '589411ec-1b36-488f-b381-c5b2c8a40f89',
  S12 = '071346ab-f6a0-47d2-a717-60ead4916824',
  S13 = '33de712d-bd42-4aea-b5e3-66efa2fd7c79',
  S14 = 'a9850d0d-b56b-4bb7-a88c-5d3d6d58f7d2',
  S15 = '9c88d8cf-de96-42aa-ba2c-4ee6cc9ceb71',
  S16 = '214840b2-e76c-4f0d-928a-4d5bff77b9d1',
  S17 = '732d275f-2057-4eec-bee8-8bc827f568b4',
  S18 = '801b8ef8-8e5d-4960-8112-2ddcca764562',
  S19 = 'c1dce190-d879-4daf-abb5-77016d29d41e',
  S20 = '5b40b82f-a6db-4041-be87-501d53bdcb88',
}

export const SLOT_ID_TO_MULTI_STATE_BOX_STATE: Record<
  string,
  SlotsContainerState
> = {
  [SlotId.S1]: SlotsContainerState.B1,
  [SlotId.S2]: SlotsContainerState.B2,
  [SlotId.S3]: SlotsContainerState.B3,
  [SlotId.S4]: SlotsContainerState.B4,
  [SlotId.S5]: SlotsContainerState.B5,
  [SlotId.S6]: SlotsContainerState.B6,
  [SlotId.S7]: SlotsContainerState.B7,
  [SlotId.S8]: SlotsContainerState.B8,
  [SlotId.S9]: SlotsContainerState.B9,
  [SlotId.S10]: SlotsContainerState.B10,
  [SlotId.S11]: SlotsContainerState.B11,
  [SlotId.S12]: SlotsContainerState.B12,
  [SlotId.S13]: SlotsContainerState.B13,
  [SlotId.S14]: SlotsContainerState.B14,
  [SlotId.S15]: SlotsContainerState.B15,
  [SlotId.S16]: SlotsContainerState.B16,
  [SlotId.S17]: SlotsContainerState.B17,
  [SlotId.S18]: SlotsContainerState.B18,
  [SlotId.S19]: SlotsContainerState.B19,
  [SlotId.S20]: SlotsContainerState.B20,
};

enum SettingsSlotId {
  S1 = 'a7bad25a-e83c-41ce-b7e1-1836491649c8',
  S2 = 'd0cfeea1-8d07-40ce-86f0-0386066fe4d7',
  S3 = '2a090849-8d51-4d69-bb72-418da1351419',
  S4 = '8a985827-f822-4424-978f-b367c8ab275d',
  S5 = '93ee4c67-2c02-4b2d-a05b-6042a86ae1c5',
  S6 = '44bca380-13b1-43b8-a158-080dcd18ae9d',
  S7 = 'b6afd8d1-4be7-4263-8fda-b47070b9348a',
  S8 = '1a66a303-f582-4178-85f5-27f551761319',
}

export const SETTINGS_SLOT_ID_TO_MULTI_STATE_BOX_STATE: Record<
  string,
  SettingsSlotsContainerState
> = {
  [SettingsSlotId.S1]: SettingsSlotsContainerState.B1,
  [SettingsSlotId.S2]: SettingsSlotsContainerState.B2,
  [SettingsSlotId.S3]: SettingsSlotsContainerState.B3,
  [SettingsSlotId.S4]: SettingsSlotsContainerState.B4,
  [SettingsSlotId.S5]: SettingsSlotsContainerState.B5,
  [SettingsSlotId.S6]: SettingsSlotsContainerState.B6,
  [SettingsSlotId.S7]: SettingsSlotsContainerState.B7,
  [SettingsSlotId.S8]: SettingsSlotsContainerState.B8,
};

// Following are legacy definitions which will be removed when `se_pluggable_slots` experiment is turned on for users
enum SlotRoleId {
  S1 = 's1',
  S2 = 's2',
  S3 = 's3',
  S4 = 's4',
  S5 = 's5',
  S6 = 's6',
  S7 = 's7',
  S8 = 's8',
  S9 = 's9',
  S10 = 's10',
  S11 = 's11',
  S12 = 's12',
  S13 = 's13',
  S14 = 's14',
  S15 = 's15',
  S16 = 's16',
  S17 = 's17',
  S18 = 's18',
  S19 = 's19',
  S20 = 's20',
}

export const SLOT_ROLE_ID_TO_MULTI_STATE_BOX_STATE: Record<
  string,
  SlotsContainerState
> = {
  [SlotRoleId.S1]: SlotsContainerState.B1,
  [SlotRoleId.S2]: SlotsContainerState.B2,
  [SlotRoleId.S3]: SlotsContainerState.B3,
  [SlotRoleId.S4]: SlotsContainerState.B4,
  [SlotRoleId.S5]: SlotsContainerState.B5,
  [SlotRoleId.S6]: SlotsContainerState.B6,
  [SlotRoleId.S7]: SlotsContainerState.B7,
  [SlotRoleId.S8]: SlotsContainerState.B8,
  [SlotRoleId.S9]: SlotsContainerState.B9,
  [SlotRoleId.S10]: SlotsContainerState.B10,
  [SlotRoleId.S11]: SlotsContainerState.B11,
  [SlotRoleId.S12]: SlotsContainerState.B12,
  [SlotRoleId.S13]: SlotsContainerState.B13,
  [SlotRoleId.S14]: SlotsContainerState.B14,
  [SlotRoleId.S15]: SlotsContainerState.B15,
  [SlotRoleId.S16]: SlotsContainerState.B16,
  [SlotRoleId.S17]: SlotsContainerState.B17,
  [SlotRoleId.S18]: SlotsContainerState.B18,
  [SlotRoleId.S19]: SlotsContainerState.B19,
  [SlotRoleId.S20]: SlotsContainerState.B20,
};

enum SettingsSlotRoleId {
  S1 = 's1',
  S2 = 's2',
  S3 = 's3',
  S4 = 's4',
  S5 = 's5',
  S6 = 's6',
  S7 = 's7',
  S8 = 's8',
}

export const SETTINGS_SLOT_ROLE_ID_TO_MULTI_STATE_BOX_STATE: Record<
  string,
  SettingsSlotsContainerState
> = {
  [SettingsSlotRoleId.S1]: SettingsSlotsContainerState.B1,
  [SettingsSlotRoleId.S2]: SettingsSlotsContainerState.B2,
  [SettingsSlotRoleId.S3]: SettingsSlotsContainerState.B3,
  [SettingsSlotRoleId.S4]: SettingsSlotsContainerState.B4,
  [SettingsSlotRoleId.S5]: SettingsSlotsContainerState.B5,
  [SettingsSlotRoleId.S6]: SettingsSlotsContainerState.B6,
  [SettingsSlotRoleId.S7]: SettingsSlotsContainerState.B7,
  [SettingsSlotRoleId.S8]: SettingsSlotsContainerState.B8,
};
